import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet"
import L from "leaflet"
import "leaflet/dist/leaflet.css"

const markerIcon = new L.Icon({
   iconUrl:
      "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/Icons%2Ficon_cross.png?alt=media&token=b61c87e7-bf81-41bf-a457-671ecc510e3e",
   iconSize: [25, 41],
   iconAnchor: [10, 20],
})

const MapFlyToShop = ({ shop }) => {
   const map = useMap()

   useEffect(() => {
      if (shop?.lat != null && shop?.lng != null) {
         map.flyTo([shop.lat, shop.lng], 15)
      }
   }, [map, shop])

   return null
}

const ShopMap = ({ shops, selectedShop }) => {
   return (
      <MapContainer
         center={[46.587908, 5.590063]}
         zoom={6}
         style={{ height: "60vh", width: "100%", filter: "grayscale(100%)" }}
         scrollWheelZoom={true}
      >
         <TileLayer
            attribution="&copy; OpenStreetMap contributors & CartoDB"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
         />
         {selectedShop && <MapFlyToShop shop={selectedShop} />}

         {shops.map((shop, index) => (
            <Marker
               key={index}
               position={[shop.lat, shop.lng]}
               icon={markerIcon}
            >
               <Popup>
                  <div>
                     <strong>{shop.name}</strong>
                     <br />
                     📞 {shop.phone}
                     <br />
                     ✉️ <a href={`mailto:${shop.mail}`}>{shop.mail}</a>
                  </div>
               </Popup>
            </Marker>
         ))}
      </MapContainer>
   )
}

ShopMap.propTypes = {
   shops: PropTypes.arrayOf(PropTypes.object),
   selectedShop: PropTypes.object,
}

export default ShopMap
